// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fgqaxykqdudpgagiahbg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZncWF4eWtxZHVkcGdhZ2lhaGJnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI4NDg3NjksImV4cCI6MjA1ODQyNDc2OX0.4XrwTlAzhnDytHBWMUHi3LloBNv8W9DMzWscWwuyVTc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);